
<template>
  <div>
    <v-dialog :value="dialog" scrollable persistent  max-width="800px" transition="dialog-transition">
      <v-card>
        <v-card-title>
          <span class="headline">Editando dados do funcionário</span>
        </v-card-title>
        <v-card-text>
          <EmployeeInfoForm ref="form" :user_attributes="new_employee.user_attributes" :teamModel="new_employee" has_email></EmployeeInfoForm>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn cancel @click="closeDialog" ></f-btn>
          <f-btn save @click="emitUpdate" :disabled="!check" ></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import validations from "@/mixins/validations.js"
export default {
  name: 'EmployeeEditInfoDialog',
  mixins: [ validations ],
  props: {
    employee:{
      type: Object,
      default: () => { return {} },
    },
    change_dialog:{
      type: Boolean,
      default: false,
    }
  },
  components:{
    EmployeeInfoForm: () => import("@/_backoffice/_registrations/components/employee/forms/EmployeeInfoForm.vue"),
  },
  data() {
    return {
      new_employee:{
        id: null
      },
      dialog: false,
      check: true,
      cpfOK: true,
    }
  },
  methods: {
    emitUpdate(){
      if(this.$refs.form.validate()){
        this.$emit('update', this.new_employee)
      }
    },
    closeDialog(){
      this.$emit('close')
    },

  },
  watch:{
    change_dialog(nv, old){
      this.dialog = nv
    },
    dialog(nv) {
      if (nv) {
        this.new_employee = {
          id: this.employee.data.attributes.id,
          team: this.employee.data.attributes.team || 'none',
          user_attributes: {
            id: this.employee.data.attributes.user_id,
            name: this.employee?.data?.attributes?.name,
            cpf: this.employee.data.attributes.cpf,
            email: this.employee.data.attributes.email,
          }
        }
      }
    },
  }
}
</script>